import React from "react";
import { motion } from "framer-motion";
import { KPL_LOGO } from "../../constants/siteContent";
import { fadeInUp, staggerContainer } from "../../lib/animations";

export const VisionSection = () => {
  return (
    <section id="vision" data-testid="vision-section" className="py-24 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}>
          <motion.img variants={fadeInUp} src={KPL_LOGO} alt="KPL" className="w-24 h-24 mx-auto mb-7 object-contain" />
          <motion.h2 variants={fadeInUp} className="font-editorial text-3xl md:text-5xl lg:text-6xl text-[#0A0A0A] mb-5 leading-[1.02] italic">
            Restructure, Rebrand and Reposition
          </motion.h2>
          <motion.p variants={fadeInUp} className="mx-auto max-w-4xl text-lg md:text-xl text-[#0A0A0A]/70 leading-relaxed">
            Our goal is to take KPL Member Clubs to a greater standard of
            <strong className="text-[#D1111A]"> professionalism</strong>,
            <strong className="text-[#D1111A]"> corporate governance</strong> and
            <strong className="text-[#D1111A]"> financial sustainability</strong>.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};